import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## Välkommen till Intern IT

Portalen är en navigations- och kunskapsvy över den observerade Intern IT-miljön.
Git-baserad Markdown och katalogbeskrivningar är källan; länkade driftsystem
är fortsatt auktoritativa för aktuell status.

### Börja här

- [System och komponenter](/catalog?filters%5Bkind%5D=system)
- [Infrastrukturresurser](/catalog?filters%5Bkind%5D=resource)
- [API:er](/catalog?filters%5Bkind%5D=api)
- [TechDocs](/docs)
- [Service & URL Directory](/service-directory)
- [Kataloggraf](/catalog-graph)
- [Informationsflödesgraf](/information-flow)
- [Discovery-rapport](/docs/default/system/intern-it-portal/discovery-report/)
- [Slutlig acceptansrapport](/docs/default/system/intern-it-portal/final-report/)

### Statusmarkeringar

- **production**: observerad aktiv drift
- **experimental**: isolerad POC eller syntetisk/labbfunktion
- **unknown**: historisk uppgift som kräver live-verifiering
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Intern IT',
    description: 'Navigera från system till dokumentation och driftlänkar',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
